export const educationPrograms = [
  {
    id: 'ioc',
    web: 'ioc.xtec.cat',
    url: 'https://ioc.xtec.cat/educacio/cfgs-daw',
  },
  {
    id: 'barcelona_activa',
    web: 'barcelonactiva.cat',
    url: 'https://www.barcelonactiva.cat/es/itacademy',
  },
  {
    id: 'upc_school',
    web: '',
    url: '',
  }
];
